import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import Root from './pages/Root/Root';
import Contexts from './contexts/Contexts';
import UploadingDialog from './Components/UploadingDialog';
import themeDark from './UI/Themes/ThemeDark';
import useQuery from './customHooks/useQuery';
import { customTheme } from './pages/Root/Basic/SVPlay/utils';
import { getImageUrl, getRootDomain } from './utils/helpers/helperfunctions';
import useWhitelabelClient from './customHooks/whitelabel/useWhitelabelClient';

function App() {
  const {
    loadingSpinnerEnabled,
    setWhitelabelClient,
    whitelabelClient,
  } = useContext(Contexts);

  const { client } = useWhitelabelClient(
    getRootDomain(window.location.hostname),
  );

  const query = useQuery();
  const mode = query.get('mode');

  useEffect(() => {
    if (!client) return;
    setWhitelabelClient(client);
  }, [client]);

  const meta = whitelabelClient?.metadata || {};
  const title =
    meta.title || whitelabelClient?.basic_config?.name || 'Accounts';
  const favicon = getImageUrl(meta.favicon_url) || '/favicon.ico';
  const description = meta.description || '';
  const keywords = Array.isArray(meta.keywords) ? meta.keywords.join(', ') : '';
  const author = meta.author || '';
  const ogImage = getImageUrl(meta.og_image_url) || '';
  const ogTitle = meta.og_title || title;
  const ogDescription = meta.og_description || description;
  const ogSiteName = meta.og_site_name || title;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <link rel="icon" href={favicon} type="image/png" />
        <link rel="apple-touch-icon" href={favicon} type="image/png" />
        {description && <meta name="description" content={description} />}
        {keywords && <meta name="keywords" content={keywords} />}
        {author && <meta name="author" content={author} />}
        {ogImage && <meta property="og:image" content={ogImage} />}
        {ogTitle && <meta property="og:title" content={ogTitle} />}
        {ogDescription && (
          <meta property="og:description" content={ogDescription} />
        )}
        {ogSiteName && <meta property="og:site_name" content={ogSiteName} />}
      </Helmet>
      <ThemeProvider theme={mode === 'SV_PLAY' ? customTheme : themeDark}>
        <CssBaseline />
        <Router>
          <Root mode={mode} />
        </Router>
        <UploadingDialog text="" open={loadingSpinnerEnabled} />
      </ThemeProvider>
    </>
  );
}

export default App;
